/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePersonPermissionRequest
 */
export interface UpdatePersonPermissionRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdatePersonPermissionRequest
     */
    permissions?: Array<string>;
}

/**
 * Check if a given object implements the UpdatePersonPermissionRequest interface.
 */
export function instanceOfUpdatePersonPermissionRequest(value: object): value is UpdatePersonPermissionRequest {
    return true;
}

export function UpdatePersonPermissionRequestFromJSON(json: any): UpdatePersonPermissionRequest {
    return UpdatePersonPermissionRequestFromJSONTyped(json, false);
}

export function UpdatePersonPermissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePersonPermissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'permissions': json['permissions'] == null ? undefined : json['permissions'],
    };
}

export function UpdatePersonPermissionRequestToJSON(json: any): UpdatePersonPermissionRequest {
    return UpdatePersonPermissionRequestToJSONTyped(json, false);
}

export function UpdatePersonPermissionRequestToJSONTyped(value?: UpdatePersonPermissionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'permissions': value['permissions'],
    };
}

